// extracted by mini-css-extract-plugin
module.exports = {"container":"_3eyHJVvAgHLyur5zLB-MrS","description":"_1TcS4AQFZFEB4ZXeRdHJq description"};